import React, {useState, useContext} from 'react';
import InputField from './components/InputField';
import {Button} from 'reactstrap';
import Header from './components/Header';
import Preview from './components/Preview';
import {getYoutubeCreationPreview, createYoutubeFeed} from 'utils/api';
import {toast} from 'react-toastify';
import {connect} from 'react-redux';
import {ErrorContext} from 'contexts/ErrorContext';
import {useHistory} from 'react-router-dom';
import {sortObjects} from 'Helpers/sortObjects';
import SpinnerButton from 'components/SpinnerButton';

const YoutubeInput = (props) => {
    let history = useHistory();

    const {handleErrors} = useContext(ErrorContext);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [creationLoading, setCreationLoading] = useState(false);
    const [feed, setFeed] = useState(null);
    const [rssUrl, setRssUrl] = useState('');
    const [feedName, setFeedName] = useState('');
    const [keywordForSubmit, setKeywordForSubmit] = useState('');

    const getPreview = async() => {
        const data = {
            url: rssUrl.trimEnd(),
        };
        setPreviewLoading(true);
        setFeed(null);
        try {
            let source = await getYoutubeCreationPreview(data);
            setKeywordForSubmit(rssUrl.trimEnd());
            if(source.length > 100) {
                source = source.slice(0, 100);
            }
            setFeedName(source.content.title);
            let sortedByDate = sortObjects(source.content.news, 'publishedAt', 'desc');
            setFeed(sortedByDate);
            // setFeed(source.content.news);
            setPreviewLoading(false);
        } catch(err) {
            console.log(err);
            setPreviewLoading(false);
            if(err.code && err.code === 'VALIDATION_FAILED') {
                toast.error(err.message);
            } else {
                handleErrors(err);
            }
        }
    };

    const createFeed = (value) => {
        setCreationLoading(true);
        const data = {
            url: keywordForSubmit.trim(),
            title: feedName.trim(),
        };
        createYoutubeFeed(data)
            .then(() => {
                setCreationLoading(false);
                history.push('/feeds/fetches');
            })
            .catch((err) => {
                console.log(err);
                setCreationLoading(false);
                handleErrors(err);
            });
    };

    return (
        props.auth.permissions && !props.auth.permissions.includes('social') ?
            <React.Fragment>
                <Header text="Fetch posts from YouTube"/>
                <div style={{fontSize: '18px'}}>
                    To follow Youtube channels,<br/> contact Support to access this feature<br/>
                    <a style={{textDecoration: 'underline'}} href="mailto:support@newsfetch.io">
                        support@newsfetch.io
                    </a>
                </div>
            </React.Fragment>
            :
            <React.Fragment>
                <Header text="Fetch news from YouTube"/>
                <InputField
                    showSubmitGlass={true}
                    onSubmit={getPreview}
                    loading={previewLoading}
                    inputPlaceholder="Enter the YouTube channel/playlist URL"
                    parrentDataHandling={true}
                    value={rssUrl}
                    handleChange={setRssUrl}
                />
                {feed &&
                <div className="preview-container">
                    <React.Fragment>
                        <div className="twitter-input_container" style={{marginBottom: '10px'}}>
                            <InputField
                                onSubmit={createFeed}
                                loading={creationLoading}
                                inputPlaceholder="Enter the Newsfeed name"
                                showSubmitGlass={false}
                                parrentDataHandling={true}
                                value={feedName}
                                handleChange={setFeedName}
                            />
                            <div className="twitter-input_dropdown">
                                {/*<Button*/}
                                {/*    disabled={feedName.trim() === ''}*/}
                                {/*    style={{color: 'white', minWidth: '125px', margin: '0'}}*/}
                                {/*    onClick={createFeed}*/}
                                {/*    className="btn typical-button target_input-btn"*/}
                                {/*>*/}
                                {/*    {creationLoading ?*/}
                                {/*        <i className="fa fa-spinner fa-spin"/>*/}
                                {/*        :*/}
                                {/*        'Create Source'*/}
                                {/*    }*/}
                                {/*</Button>*/}
                                <SpinnerButton
                                    minWidth="125px"
                                    title="Create Source"
                                    submitting={creationLoading}
                                    onClick={createFeed}
                                    disabled={feedName.trim() === ''}
                                />
                            </div>
                        </div>
                        <div className="mt-3">
                            <Header text="Preview"/>
                            <Preview feed={feed} sourceType="twitter"/>
                        </div>
                    </React.Fragment>
                </div>
                }
            </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateToProps,
    null,
)(YoutubeInput);
